import React, { useState } from "react";
import { postRequestGenerator } from "../../helpers/httpHelper";
import {
  TextField,
  Button,
  Typography,
  Divider,
  Stack,
  Box,
  Modal,
} from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid",
  borderColor: "primary.main",
  boxShadow: 24,
  borderRadius: 3,
  pt: 2,
  px: 4,
  pb: 3,
};

export default function ModalSetNicNotes({
  open,
  closeNicNotesModal,
  newsData,
  id,
  isAuthState,
  tokenState,
  setIsAuthState,
  patchEnabled,
  // setNewsData,
}) {
  const newsItem = newsData.filter((e) => e.news.id === id)[0];
  const [nicNoteDataToPatch, setNicNoteDataToPatch] = useState({});

  const onChangeNotes = (e) => {
    setNicNoteDataToPatch({
      ...nicNoteDataToPatch,
      [e.target.name]: e.target.value,
    });
  };

  const changeNicNoteInOriginalObject = (newsDataToChange) => {
    newsDataToChange.forEach((e, i) => {
      if (e.news.id === id) {
        e.news.nicNote = nicNoteDataToPatch.nicNote;
      }
    });
    // setNewsData([...newsDataToChange]);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (isAuthState && Object.entries(nicNoteDataToPatch).length > 0) {
      const patchNewsApi = postRequestGenerator({
        url: `atomic/news/${id}`,
        queryType: "PATCH",
        tokenState: tokenState,
        isAuthState: setIsAuthState,
        body: {
          ...nicNoteDataToPatch,
        },
      });
      patchNewsApi().then(() => {
        changeNicNoteInOriginalObject(newsData);
        setNicNoteDataToPatch({});
      });
    }
    closeNicNotesModal();
  };

  return (
    <Modal
      open={open}
      onClose={closeNicNotesModal}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <form onSubmit={onSubmit}>
        {/* Ho lasciato il Box esterno, ma ho modificato lo Stack interno */}
        <Box sx={{ ...style, width: 450, maxHeight: "70vh" }}>
          <Stack spacing={2} padding={1}>
            <Typography
              color={"primary.main"}
              id="parent-modal-title"
              sx={{
                fontSize: "1.2rem",
                fontWeight: 500,
              }}
            >
              Informazioni dallo staff NIC
            </Typography>
            <Divider />

            {/*
              MODIFICHE QUI:
              1. Rimosso il <Box> e <Container> che avvolgevano il TextField.
              2. Aggiunto 'fullWidth', 'multiline', 'rows' e 'label' al TextField.
            */}
            <TextField
              //   label="Note dello staff"
              value={
                nicNoteDataToPatch.nicNote ?? newsItem?.news?.nicNote ?? ""
              }
              disabled={!patchEnabled}
              onChange={onChangeNotes}
              required={true}
              color="primary"
              name="nicNote" // Lascio questo per non rompere la tua logica
              fullWidth // <-- LA MAGIA È QUI
              multiline
              rows={5} // <-- Imposta un'altezza di default
            />

            <Divider />
            <Stack direction={"row-reverse"}>
              {patchEnabled && (
                <>
                  <Button
                    type="submit"
                    sx={{ color: "white" }}
                    variant="contained"
                    onSubmit={onSubmit}
                  >
                    {"SALVA"}
                  </Button>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={closeNicNotesModal}
                    sx={{
                      marginRight: 2,
                    }}
                  >
                    {"INDIETRO"}
                  </Button>
                </>
              )}
              {!patchEnabled && (
                <Button
                  type="submit"
                  sx={{ color: "white" }}
                  variant="contained"
                  onSubmit={closeNicNotesModal}
                >
                  {"CHIUDI"}
                </Button>
              )}
            </Stack>
          </Stack>
        </Box>
      </form>
    </Modal>
  );
}
